var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6017",
    "data-name": "Group 6017",
    transform: "translate(-908 -401)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_329",
    "data-name": "Ellipse 329",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(908 401)",
    fill: "#e8f1ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Inventory_1_",
    transform: "translate(912.718 394.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M80.027,80.026",
    transform: "translate(-15.372 -32.104)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 19,
    transform: "translate(53.078 61.9)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 19,
    transform: "translate(23.26 39.922)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 19,
    transform: "translate(53.078 77.9)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x2: 19,
    transform: "translate(23.26 55.922)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x2: 19,
    transform: "translate(53.078 69.9)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x2: 19,
    transform: "translate(23.26 47.922)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    y2: 6,
    transform: "translate(66.078 66.9)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    y2: 6,
    transform: "translate(36.26 44.922)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    y2: 6,
    transform: "translate(59.078 58.9)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    y2: 6,
    transform: "translate(29.26 36.922)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    y2: 6,
    transform: "translate(59.078 74.9)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    y2: 6,
    transform: "translate(29.26 52.922)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M426.369,337.823a8.146,8.146,0,0,1-7.754,13.688",
    transform: "translate(486.2 -239.077) rotate(106)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M426.369,337.823a8.146,8.146,0,0,1-7.754,13.688",
    transform: "translate(-390.257 358.782) rotate(-74)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M420.7,441.606l-2.036,2.036,2.036,2.316",
    transform: "translate(574.796 -213.72) rotate(106)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M420.7,441.606l-2.036,2.036,2.036,2.316",
    transform: "translate(-478.853 333.425) rotate(-74)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.7494fac302600d424b079e655d270cb6.svg";
export { ForwardRef as ReactComponent };